/* li-m-motion.js — MOTION-LAB 15.10.2026 · site motion system (deferred; ~2 KB gz). See li-m-motion.css for the map.
   Reveal: one per section (its heading block), only below the first screen (no flash, no LCP/CLS cost).
   PDP hover zoom: fine pointer only, follows the cursor (eased), off on touch. View transitions: card image → PDP lead morph.
   Cart count bump on change. Never touches the coded sections (li-m-evap / li-m-finder own their motion). */
(() => {
  const RM = matchMedia('(prefers-reduced-motion: reduce)');
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const main = document.getElementById('MainContent');

  /* 1 · reveal — ONE entrance per section (AUDIT-R4 move 5: "fade-up on everything" was the motion tell). Only the section's
     heading block animates, and only when it starts below the first screen; item-level .li-reveal staggers are switched off in CSS. */
  if (main && !RM.matches && 'IntersectionObserver' in window) {
    const vh = innerHeight;
    const io = new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }),
      { rootMargin: '0px 0px -10% 0px', threshold: .01 });
    $$('.shopify-section', main).forEach(sec => {
      if (sec.querySelector('.m-ev, .m-fd, .ag-hero, .li-pdp, .li-drawer')) return;     // coded sections + hero + PDP own their motion
      const h = sec.querySelector('h2'); if (!h) return;
      const blk = h.closest('[class*="__head"], [class*="__intro"], [class*="__hl"], [class*="__top"]') || h;
      if (blk.closest('[data-li-track]')) return;
      const r = blk.getBoundingClientRect(); if (r.top < vh * .92 || r.height === 0) return;
      blk.classList.add('m-rv'); io.observe(blk);
    });
    setTimeout(() => $$('.m-rv:not(.is-in)').forEach(el => { if (el.getBoundingClientRect().top < innerHeight) el.classList.add('is-in'); }), 5000);
  }

  /* 3 · PDP hover zoom */
  if (matchMedia('(hover: hover) and (pointer: fine)').matches && !RM.matches) {
    $$('.li-pdp__slide').forEach(sl => {
      let raf = 0, tx = 50, ty = 50, x = 50, y = 50, t;
      const step = () => { x += (tx - x) * .18; y += (ty - y) * .18; sl.style.setProperty('--m-zx', x.toFixed(2) + '%'); sl.style.setProperty('--m-zy', y.toFixed(2) + '%');
        raf = (Math.abs(tx - x) + Math.abs(ty - y) > .05) ? requestAnimationFrame(step) : 0; };
      sl.addEventListener('pointerenter', e => { if (e.pointerType !== 'mouse') return; clearTimeout(t); t = setTimeout(() => sl.classList.add('is-zoom'), 140); });
      sl.addEventListener('pointermove', e => { if (e.pointerType !== 'mouse') return; const r = sl.getBoundingClientRect();
        tx = ((e.clientX - r.left) / r.width) * 100; ty = ((e.clientY - r.top) / r.height) * 100; if (!raf) raf = requestAnimationFrame(step); });
      sl.addEventListener('pointerleave', () => { clearTimeout(t); sl.classList.remove('is-zoom'); });
      sl.addEventListener('click', () => { clearTimeout(t); sl.classList.remove('is-zoom'); });
    });
  }

  /* 5 · view transitions: the clicked product image becomes the PDP lead (pagereveal side = inline script in snippets/li-m-motion) */
  addEventListener('pageswap', e => {
    if (!e.viewTransition) return;
    const to = e.activation && e.activation.entry && e.activation.entry.url;
    const m = to && to.match(/\/products\/([^/?#]+)/);
    const a = window.__mVtA; window.__mVtA = null;
    if (!m || !a) { try { sessionStorage.removeItem('m-vt'); } catch (x) {} return; }
    const img = a.querySelector('img'); if (!img) return;
    img.style.viewTransitionName = 'm-hero';
    try { sessionStorage.setItem('m-vt', m[1]); } catch (x) {}
    e.viewTransition.finished.finally(() => { img.style.viewTransitionName = ''; });
  });
  document.addEventListener('click', e => {
    const a = e.target.closest('a[href*="/products/"]');
    window.__mVtA = a && a.querySelector('img') && !a.closest('.li-pdp') ? a : null;
  }, true);

  /* 6 · cart count bump */
  const counts = $$('[data-li-cart-count]');
  if (counts.length && 'MutationObserver' in window && !RM.matches) {
    const mo = new MutationObserver(ms => ms.forEach(m => { const el = m.target.nodeType === 3 ? m.target.parentElement : m.target;
      if (!el) return; el.classList.remove('m-bump'); void el.offsetWidth; el.classList.add('m-bump'); }));
    counts.forEach(c => mo.observe(c, { childList: true, characterData: true, subtree: true }));
  }
})();
